import { differenceInMilliseconds, isValid } from 'date-fns';
import { IntlShape } from 'react-intl';

export const formatCommentDate = (value: string, intl: IntlShape) => {
  const date = new Date(value);
  if (!isValid(date)) return null;

  return {
    date: intl.formatDate(date, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }),
    time: intl.formatDate(date, {
      hour: 'numeric',
      minute: '2-digit',
    }),
  };
};

export const isCommentEdited = ({
  createdAt,
  modifiedAt,
}: {
  createdAt: string;
  modifiedAt: string;
}) => {
  const createdAtDate = new Date(createdAt);
  const modifiedAtDate = new Date(modifiedAt);

  if (!isValid(createdAtDate) || !isValid(modifiedAtDate)) return false;

  // Backend creates modifiedAt date at first creation even though its technically only created and not modified.
  // as a workaround we assume any comment that is "modified" within the first n seconds of its creation is not "edited".
  return differenceInMilliseconds(modifiedAtDate, createdAtDate) > 5000;
};
